import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeModeScript, ThemeProvider } from 'flowbite-react';
import './index.css';
import App from './App.tsx';
import { LocaleProvider } from './context/LocaleContext';
import { initializeThemePreference, ThemePreferenceProvider } from './context/ThemePreferenceContext';

initializeThemePreference();

const flowbiteTheme = {
  button: {
    color: {
      default:
        'bg-blue-700 text-white hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800',
      light:
        'border border-slate-300 bg-slate-50 text-slate-900 hover:border-slate-400 hover:bg-slate-100 focus:ring-slate-200 dark:border-slate-500 dark:bg-slate-700 dark:text-slate-50 dark:hover:border-slate-400 dark:hover:bg-slate-600 dark:focus:ring-slate-700',
    },
  },
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeModeScript defaultMode="light" />
    <ThemeProvider theme={flowbiteTheme}>
      <ThemePreferenceProvider>
        <LocaleProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocaleProvider>
      </ThemePreferenceProvider>
    </ThemeProvider>
  </StrictMode>,
);
